<script lang="ts">
	import type { GameReport } from '#lib/schema-extension.js';
	import { setAttr } from '@directus/visual-editing';
	import HdGameReport, {
		type HDGameReportOptions
	} from '#lib/hockeydata/components/HDGameReport.svelte';

	let { block }: { block: GameReport } = $props();
</script>

<div
	data-directus={setAttr({
		collection: 'gameReport',
		item: block.id!!,
		mode: 'modal'
	})}
>
	<HdGameReport
		gameId={block.gameId.gameId}
		options={block.sections as HDGameReportOptions}
		title={block.title}
	/>
</div>
